//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import { getUrlparams } from "@/utils/util.js";
import footerNav from "@/components/footerNav";
import zwtp from "../../assets/img/zwtp.png";

export default {
  name: "viewActivitiesSelection",
  components: {
    footerNav
  },
  data() {
    return {
      item: {},
      loading: false,
      isShow: false,
      finished: false,
      show: true,
      spuDeptId: "",
      showPicker: false,
      columns: [],
      values: [],
      spuDeptName: "",
      zwtp,
      start: 0,
      size: 0,
      itemList: []
    };
  },
  created() {},
  mounted() {
    this.getQuery();
    this.item = JSON.parse(this.$route.query.row);
  },
  methods: {
    onSubmit(val) {
      if (val.spuDeptName != "") {
        this.show = false;
        this.spuDeptId = this.columns[0].children[0].id;
        this.onLoad();
      } else {
        Toast("请选择渠道");
      }
    },
    getQuery() {
      axiosApi
        .getSampleSelectList({ deptType: "channel" })
        .then(sty => {
          sty.content.forEach(item => {
            item.text = item.name;
            item.children.forEach(ele => {
              ele.text = ele.name;
            });
          });
          this.columns = sty.content;
        })
        .catch(err => {});
    },
    onConfirm(value, values) {
      this.values = values;
      var val = value[0] + "-" + value[1];
      this.spuDeptName = val;
      this.showPicker = false;
    },
    cancel() {
      this.showPicker = false;
    },
    bottomClick() {
      this.$router.push({ name: "activitiesSelection" });
    },
    GridCheck(item) {
      item.checked = !item.checked;
    },
    onLoad() {
      this.size = this.size + 20;
      axiosApi
        .getSampleMobileDeptView({
          start: this.start,
          size: this.size,
          sampleSelectId: this.item.sampleSelectId,
          spuDeptId: this.spuDeptId,
          orderRules: [
            {
              orderKey: "t1.sampleId",
              desc: true
            }
          ]
        })
        .then(response => {
          if (
            response.content &&
            response.content.list &&
            response.content.list.length > 0
          ) {
            response.content.list.forEach(item => {
              item.checked = false;
              if (
                item.predictedSampleCost &&
                item.predictedSampleCost != "" &&
                item.predictedSampleCost != null
              ) {
              } else {
                item.predictedSampleCost = "暂无";
              }
            });
            var List = JSON.parse(JSON.stringify(this.itemList));
            this.itemList.splice(0, this.itemList.length);
            this.itemList = response.content.list;
            this.itemList.forEach(item => {
              List.forEach(element => {
                if (element.sampleSelectDetailId == item.sampleSelectDetailId) {
                  item.checked = element.checked;
                }
              });
            });
          } else {
            this.itemList = [];
          }
          this.loading = false;
          if (this.itemList.length == response.content.total) {
            this.finished = true;
          }
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/centerOrder/viewActivitiesSelection.vue